<template>
  <div class="container pt-2 pt-md-4 page-content">
    <div class="row">
      <div class="col-12">
        <h1>Termos e condições do RADAR PESSOAL</h1>
        <p>
          O presente Termo de Uso (“TERMO”) estabelecerá as condições de acesso e uso do serviço RADAR PESSOAL da
          <b>BOA VISTA SERVIÇOS S.A</b>, com sede na cidade de Barueri e estado de São Paulo, na Avenida Tamboré, n.º 267, Edifício
          Canopus, Torre Sul, 11º ao 15º pavimento, Bairro Tamboré, CEP 06460-000, inscrita no CNPJ/MF sob o n.º11.725.176/0001-27
          (“
          <b>BOA VISTA SCPC</b>”), que se regerá pelas cláusulas e condições a seguir:
        </p>
        <ul class="main-list">
          <li>
            <b>1.</b> O RADAR PESSOAL é um serviço de monitoramento de movimentação de informações de inclusão e exclusão de registro
            de débitos constantes no banco de dados da
            <b>BOA VISTA SCPC</b> relativas ao CPF de sua titularidade, e o envio de tais informações pela
            <b>BOA VISTA SCPC</b> ao seu e-mail cadastrado, por intermédio do Relatório do RADAR PESSOAL, estritamente para seu
            uso pessoal.</li>

          <li>
            <b>2.</b> Caso não tenha ocorrido movimentação de informações, você receberá mensalmente um e-mail informando sobre
            a ausência de alterações relativas ao seu CPF nas bases de dados da
            <b>BOA VISTA SCPC</b>.</li>

          <li>
            <b>3.</b> A validade do PLANO GRATUITO é de 12 (doze) meses a contar da data do envio do primeiro Relatório, após o
            que expirará automaticamente, cessando o envio do Relatório do RADAR PESSOAL.</li>

          <li>
            <b>4.</b> Na utilização do RADAR PESSOAL você deverá:

            <ul>
              <li>a) Respeitar a correta utilização das informações fornecidas por intermédio do Relatório do RADAR PESSOAL, exclusivamente
                para uso próprio;</li>

              <li>b) Informar no momento do preenchimento do cadastro um endereço válido de e-mail de sua titularidade para o recebimento
                dos e-mails com o Relatório do RADAR PESSOAL;</li>

              <li>c) Caso esta modalidade esteja disponível, cadastrar um telefone celular de sua titularidade para o recebimento
                de mensagens de SMS com a notificação sobre o envio do e-mail;</li>

              <li>d) Garantir que o e-mail e o celular (se for o caso) não tenham restrições para o recebimento de informações do
                serviço RADAR PESSOAL, devendo, para o e-mail garantir a aplicabilidade das configurações de anti-spam, firewall
                e outras pertinentes ao efetivo funcionamento. Não faz parte das atribuições da
                <b>BOA VISTA SCPC</b> garantir a entrega final ou o tempo máximo para o recebimento do e-mail, uma vez que este
                serviço não é de propriedade da BOA VISTA SCPC;
              </li>

              <li>e) Manter o e-mail, número do telefone celular (se for o caso) e demais dados cadastrais sempre atualizados na
                <b>BOA VISTA SCPC</b>.</li>
            </ul>
          </li>

          <li>
            <b>5.</b> Você assume total responsabilidade e garante à
            <b>BOA VISTA SCPC</b> e a terceiros a veracidade e exatidão dos seus dados fornecidos, isentando a
            <b>BOA VISTA SCPC</b> de qualquer responsabilidade no caso da inexatidão dos dados introduzidos nos formulários e cadastros
            realizados junto a
            <b>BOA VISTA SCPC</b>, omissão de informação relevante, ou inserção de dados falsos que possam induzir em erro.</li>

          <li>
            <b>6.</b> Na utilização do RADAR PESSOAL é expressamente vedado:

            <ul>
              <li>a) Realizar quaisquer alterações que impliquem em mudança de teor ou conteúdo das informações contidas no Relatório
                Cadastral do RADAR PESSOAL;</li>

              <li>b) Divulgar, transferir, ceder ou repassar a terceiros, a título oneroso ou não, as informações contidas no Relatório
                do RADAR PESSOAL, que são de caráter sigiloso, individual e intransferível.</li>
            </ul>
          </li>


          <li>
            <b>7.</b>Você será integralmente responsável perante a
            <b>BOA VISTA SCPC</b> e terceiros por qualquer reclamação relacionada ao uso indevido das informações cedidas por meio
            deste TERMO.</li>

          <li>
            <b>8.</b>
            <b>A BOA VISTA SCPC</b> deverá:
            <ul>
              <li>a) Controlar e informar as versões, atualizações, alterações e ajustes do serviço RADAR PESSOAL;</li>
              <li>b) Informar a cada manutenção programada advertindo sobre possível impacto em termos de disponibilidade do serviço.</li>
            </ul>
          </li>

          <li>
            <b>9.</b> A
            <b>BOA VISTA SCPC</b> é responsável pela administração do(s) Banco(s) de Dados objeto do presente TERMO, envolvendo-se
            nas atividades de recepção, arquivamento e disponibilização das informações armazenada(s). Os dados e as informações
            disponibilizadas pela
            <b>BOA VISTA SCPC</b> constituem a totalidade das informações a que a
            <b>BOA VISTA SCPC</b> teve acesso, o que não significa dizer que tais informações correspondem a todas as empresas existentes
            no mercado. Além disto,a
            <b>BOA VISTA SCPC</b> disponibiliza as informações conforme lhe são fornecidas legalmente por fontes públicas e privadas,
            cabendo-lhe, tão somente, atualizar as informações constantes no banco de dados. Assim sendo, nenhuma indenização
            lhe será devida pela
            <b>BOA VISTA SCPC</b> em razão de erros, imprecisões ou mesmo omissões no conteúdo ou na substância destas informações,
            que têm caráter meramente subsidiário e de referência.
          </li>

          <li>
            <b>10.</b> As notificações, comunicações ou informações entre as Partes deverão ser feitas por escrito, através de carta
            ou e-mail, e dirigidas aos endereços indicados pelas Partes. Caso haja alterações de endereço, e-mail ou número do
            celular (se for o caso), e você não comunique e altere seu cadastro junto à
            <b>BOA VISTA SCPC</b>, considerar-se-á válida a notificação, comunicação ou informação remetida para o endereço físico
            ou eletrônico constante no seu cadastro.
          </li>

          <li>
            <b>11.</b> O não exercício, pelas Partes, de quaisquer dos direitos ou prerrogativas previstos neste TERMO, ou mesmo
            na legislação aplicável, será tido como ato de mera liberalidade, não constituindo alteração ou novação das obrigações
            ora estabelecidas, cujo cumprimento poderá ser exigido a qualquer tempo, independentemente de comunicação prévia
            à outra Parte.</li>

          <li>
            <b>12.</b>Nenhuma das Partes será responsável por descumprimento de suas obrigações em consequência de comprovada ocorrência
            de caso fortuito ou força maior.</li>

          <li>
            <b>13.</b> Você AUTORIZA a
            <b>BOA VISTA SCPC</b>, nos termos da Lei 12.965 de 23 de abril de 2014
            <a href="http://www.planalto.gov.br/ccivil_03/_ato2011-2014/2014/lei/l12965.htm"></a>
            a proceder à coleta, armazenamento, guarda e tratamento de registros de conexão e de acesso a aplicações de internet, e fornecimento
            de dados cadastrais, pessoais ou comunicações (observadas a preservação da intimidade, vida privada, honra e imagem,
            bem como o sigilo das comunicações privadas nos termos da lei), os quais serão fornecidos e/ou utilizados pela BOA
            VISTA SCPC para as seguintes finalidades:
            <ul>
              <li>a) Comunicar a respeito de novos produtos, promoções, notícias e pesquisas da
                <b>BOA VISTA SCPC</b> e/ou de seus clientes e parceiros;</li>

              <li>b) Responder às suas dúvidas e solicitações;</li>

              <li>c) Ações de marketing e marketing services da
                <b>BOA VISTA SCPC</b> e/ou de seus clientes e parceiros;</li>

              <li>d) Produtos e serviços da
                <b>BOA VISTA SCPC</b> voltados para subsidiar o ciclo de crédito, análise de risco, prevenção a fraude e outros
                correlatos.</li>
            </ul>
          </li>

          <li>
            <b>14.</b> Você declara o seu consentimento, exarado na forma da aceitação a este TERMO com a consequente utilização
            dos produtos e serviços, em observância da Lei 12.965 de 23 de abril de 2014.
          </li>

          <li>
            <b>15.</b>Em virtude dos serviços prestados pela
            <b>BOA VISTA SCPC</b>, caso a você opte por não renovar a contratação ou cancelar o serviço ou cadastro firmado com
            a
            <b>BOA VISTA SCPC</b>, seu cadastro será desativado, mas seus dados serão mantidos armazenados para identificação caso
            haja necessidade de se apurar os acessos aos serviços.</li>

          <li>
            <b>16.</b> A
            <b>BOA VISTA SCPC</b> poderá, caso você descumpra das obrigações deste TERMO, reclamar as perdas e danos decorrentes,
            bem como, não necessariamente na ordem abaixo elencada:

            <ul>
              <li>a) Bloquear, quando for o caso, o recebimento do Relatório Cadastral do RADAR.</li>
              PESSOAL;

              <li>b) Suspender, sem aviso prévio, os SERVIÇOS; e/ou c) Cancelar definitivamente a prestação dos SERVIÇOS.</li>
            </ul>
          </li>


          <li>
            <b>17.</b> Este TERMO rege a relação entre você e a
            <b>BOA VISTA SCPC</b>, e será regido pelas leis brasileiras.</li>

          <li>
            <b>18.</b> Este TERMO refere-se à versão 001/2016. Versões posteriores poderão ser adotadas, e após devidamente registradas
            no Cartório, automaticamente substituem a versão anterior e serão publicadas no site.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "boa-vista-terms"
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/globals.scss";
.page-content {
  h1 {
    font-size: 2.5rem;
    font-weight: bold;
    color: #003c63;
    margin-bottom: 27px;
    margin-top: 52px;
  }
  h2 {
    font-size: 1.25rem;
    font-weight: bold;
    color: #343434;
    margin-bottom: 15px;
  }
  p,
  li {
    font-weight: 500;
    color: #343434;
    line-height: 1.5em;
  }


  li {
    margin-top: 1.3em;
  }

  ul {
    padding: 0;
    list-style: none;
  }
}
</style>


// WEBPACK FOOTER //
// CpfRadarTerms.vue?128e4396